export default {
  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Capital Fund" class="is-capital-fund-partial">
      <p>
        Rutherford EMC is a non-profit electric cooperative owned by the members it serves.
        As a non-profit electric cooperative, Rutherford EMC returns amounts in excess of
        operating costs and expenses to the members in the form of patronage capital credits.
        If you should move away from the Rutherford EMC service area, always make sure we are
        advised of any change of address. When patronage capital credit refunds are issued,
        they are mailed to the most recent address we have on file. In addition, when
        security deposits are refunded, they are also mailed to the most recent address we
        have on file. Rutherford EMC makes every effort to contact you if your check should
        be returned to us as undeliverable. Unclaimed patronage capital credits are forwarded
        to the State of North Carolina after three years. Unclaimed security deposits are
        forwarded to the State of North Carolina after approximately two years. An alternative
        to forwarding unclaimed monies, either patronage capital credits or security deposits,
        to the State of North Carolina is for you to sign a voluntary revocable assignment of
        these monies to Rutherford EMC. This assignment is not a requirement for you to
        receive or continue to receive service. If you make this assignment, you have the
        right to revoke it at any time before your death. Please be advised that any unclaimed
        funds that have been donated to the capital fund of Rutherford EMC prior to your
        revocation, if any, shall remain the property of Rutherford EMC. If you are willing
        to assign these unclaimed monies to Rutherford EMC, please complete and sign below.
        IN THE EVENT THAT MONIES SENT TO ME BY RUTHERFORD ELECTRIC MEMBERSHIP CORPORATION
        FOR PATRONAGE CAPITAL CREDITS OR REFUNDED SECURITY DEPOSITS ARE RETURNED AND
        REASONABLE EFFORTS TO CONTACT ME OR MY SUCCESSORS IN INTEREST ARE UNSUCCESSFUL,
        I AUTHORIZE AND DO HEREBY DONATE THE UNCLAIMED MONIES TO THE CAPITAL FUND OF
        RUTHERFORD ELECTRIC MEMBERSHIP CORPORATION.
      </p>

      <ui-form-item prop="capitalFund.enroll">
        <ui-form-radio
          name="capital_fund_enroll"
          v-model="model.capitalFund.enroll"
          label="Yes"
        />
        <ui-form-radio
          name="capital_fund_enroll"
          v-model="model.capitalFund.enroll"
          label="No"
        />
      </ui-form-item>

      <ui-form-item
        label="Applicant Signature"
        prop="capitalFund.signature"
      >
        <ui-form-input
          name="capital_fund_signature"
          v-model="model.capitalFund.signature"
        />
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
